import { RunDetailActions, RunDetailModuleState } from '@/store/run/detail'
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import { Check, ScaCheck } from '~/types/types'
import { resolveNodes } from '~/utils/array'
import { generateGlobalId } from '~/utils/hashId'

export default defineComponent({
  name: 'RunDetailMixin',

  computed: {
    ...(mapState<RunDetailModuleState>('run/detail', {
      run: (state: RunDetailModuleState) => state.run,
      check: (state: RunDetailModuleState) => state.check,
      scaCheck: (state: RunDetailModuleState) => state.scaCheck,
      checkIssues: (state: RunDetailModuleState) => state.checkIssues,
      concreteIssueList: (state: RunDetailModuleState) => state.concreteIssueList,
      scaCheckIssues: (state: RunDetailModuleState) => state.scaCheckIssues,
      runDetailLoading: (state: RunDetailModuleState) => state.loading,
      runDetailError: (state: RunDetailModuleState) => state.error,
      pageRefetchStatus: (state: RunDetailModuleState) => state.pageRefetchStatus
    }) as {
      run: () => RunDetailModuleState['run']
      check: () => RunDetailModuleState['check']
      scaCheck: () => RunDetailModuleState['scaCheck']
      checkIssues: () => RunDetailModuleState['checkIssues']
      concreteIssueList: () => RunDetailModuleState['concreteIssueList']
      scaCheckIssues: () => RunDetailModuleState['scaCheckIssues']
      runDetailLoading: () => RunDetailModuleState['loading']
      runDetailError: () => RunDetailModuleState['error']
      pageRefetchStatus: () => RunDetailModuleState['pageRefetchStatus']
    }),

    checks(): Check[] {
      return resolveNodes(this.run.checks || [])
    },
    scaChecks(): ScaCheck[] {
      return resolveNodes(this.run.scaChecks || [])
    }
  },

  methods: {
    ...mapActions('run/detail', {
      fetchRun: RunDetailActions.FETCH_RUN,
      fetchCheck: RunDetailActions.FETCH_CHECK,
      fetchScaCheck: RunDetailActions.FETCH_SCA_CHECK,
      fetchCheckIssues: RunDetailActions.FETCH_CHECK_ISSUES,
      fetchScaCheckIssues: RunDetailActions.FETCH_SCA_CHECK_ISSUES,
      fetchAutofixableIssues: RunDetailActions.FETCH_AUTOFIXABLE_ISSUES,
      fetchConcreteIssueList: RunDetailActions.FETCH_CONCRETE_ISSUE_LIST,
      createAutofixPullRequest: RunDetailActions.CREATE_AUTOFIX_PR,
      commitToPullRequest: RunDetailActions.COMMIT_TO_PR,
      createPullRequest: RunDetailActions.CREATE_PR
    }),

    getCurrentCheck(analyzerShortcode: string): Check | undefined {
      return this.checks.find((edge: Check) => edge.analyzer?.shortcode === analyzerShortcode)
    },
    getCurrentScaCheck(targetHash: string): ScaCheck | undefined {
      const targetId = generateGlobalId('RepositoryTarget', targetHash)
      return this.scaChecks.find((edge: ScaCheck) => edge.target?.id === targetId)
    }
  }
})
